module.exports = "pegasus_template/assets/themecapture1/app/104.png";